import axios from 'axios'
import { camelizeKeys } from 'humps'

import type * as ArticlePage from './types/ArticlePage'
import type * as StandardPage from './types/StandardPage'
import type * as CFDailyPage from './types/CFDailyPage'
import type * as CoursePage from './types/CoursePage'
import type { RawPage } from './types'
import articlePageParser from './parsers/ArticlePage'
import standardPageParser from './parsers/StandardPage'
import cfDailyPageParser from './parsers/CFDailyPage'
import coursePageParser from './parsers/CoursePage'

const CONTENT_URL = process.env.CONTENT_URL
const PREVIEW_CONTENT_URL = process.env.PREVIEW_CONTENT_URL

export async function fetch(path: string) {
  const baseUrl = path.endsWith('_preview') ? PREVIEW_CONTENT_URL : CONTENT_URL
  const response = await axios
    .get(`${baseUrl}?full_path=${path}`)
    .then((response) => (camelizeKeys(response.data) as unknown) as RawPage)

  switch (response.tiles[0].contentType) {
    case 'article':
      return articlePageParser(response as ArticlePage.Raw)
    case 'page':
      return standardPageParser(response as StandardPage.Raw)
    case 'cfdaily':
      return cfDailyPageParser(response as CFDailyPage.Raw)
    case 'course':
      return coursePageParser(response as CoursePage.Raw)
  }
}
